import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import Text from '../../typography/text/index.js';
import styles from './tag.module.scss.js';
import CloseBold from '../../icons/component-icons/close-bold/index.js';

const Tag = (props) => {
    const { surface: surfaceProp = 'lightPrimary', children, disabled = false, showIcon = true, 'data-testid': testId, onClick, maxWidth = '288px' } = props, rest = __rest(props, ["surface", "children", "disabled", "showIcon", 'data-testid', "onClick", "maxWidth"]);
    const surface = surfaceProp.toLowerCase();
    const containerStyles = [styles.container, styles[surface]];
    const iconStyles = [styles.icon, styles[surface]];
    const hitAreaStyles = [styles.hitArea];
    if (disabled) {
        containerStyles.push(styles.disabled);
        iconStyles.push(styles.disabled);
        hitAreaStyles.push(styles.disabled);
    }
    const _onClick = (e) => {
        // @ts-ignore
        if (onClick)
            onClick(e, { children });
    };
    return (jsxs("button", Object.assign({ title: children }, rest, { style: { maxWidth }, "data-testid": testId, className: containerStyles.join(' '), tabIndex: disabled ? -1 : 0, disabled: disabled, onClick: _onClick, children: [jsx("span", { className: hitAreaStyles.join(' ') }), jsx(Text, { primitive: "span", bold: true, color: `var(--vds-color-element-primary-on${surface})`, size: "small", kind: "body", tooltip: undefined, children: children }), showIcon && (jsx("span", { className: iconStyles.join(' '), children: jsx(CloseBold, { size: 12, color: `var(--vds-color-element-primary-on${surface})` }) }))] })));
};

export { Tag as default };
